"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mat3MultiplyVec2Shader = void 0;
const gl_shader_1 = require("../gl-shader");
/**
 * @public
 * Pad vec2 up with additional 1 and multiply.
 */
// language=GLSL
exports.mat3MultiplyVec2Shader = new gl_shader_1.GlShader(
// @formatter:off
`
#ifndef GET_MAT3_MULTIPLY_VEC2

#define GET_MAT3_MULTIPLY_VEC2 1

vec2 mat3MultiplyVec2(mat3 transform, vec2 coords)
{
    return (transform * vec3(coords, 1)).xy;
}

#endif
`);
//# sourceMappingURL=mat3-multiply-vec2-shader.js.map